import { Arrays, WeakRefSet } from "@opendaw/lib-std";
export var AudioData;
(function (AudioData) {
    const samples = new WeakRefSet();
    AudioData.count = () => samples.count();
    AudioData.create = (sampleRate, numberOfFrames, numberOfChannels) => {
        const bytesPerChannel = numberOfFrames * Float32Array.BYTES_PER_ELEMENT;
        const totalBytes = bytesPerChannel * numberOfChannels;
        const buffer = new SharedArrayBuffer(totalBytes);
        const frames = Arrays.create(i => new Float32Array(buffer, i * bytesPerChannel, numberOfFrames), numberOfChannels);
        samples.add(buffer);
        return { sampleRate, numberOfFrames, numberOfChannels, frames };
    };
})(AudioData || (AudioData = {}));
